export function formatDuration(seconds: number | null): string {
  if (seconds == null || Number.isNaN(seconds)) return "-";
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  }
  return `${m}:${String(sec).padStart(2, "0")}`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
}

/** yt-dlp upload_date is typically "YYYYMMDD"; fall back to generic date parsing. */
export function formatUploadDate(value: string | null): string {
  if (!value) return "-";
  if (/^\d{8}$/.test(value)) {
    const y = value.slice(0, 4);
    const m = value.slice(4, 6);
    const d = value.slice(6, 8);
    const date = new Date(`${y}-${m}-${d}T00:00:00Z`);
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC",
      });
    }
  }
  return formatDate(value);
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return "-";
  return n.toLocaleString();
}

export function formatCost(costUsd: number, isEstimate: boolean): string {
  const amount = `$${costUsd.toFixed(2)}`;
  return isEstimate ? `subscription (≈ ${amount} API-equivalent)` : amount;
}

export function formatReadingTime(minutes: number | null): string {
  if (minutes == null) return "";
  return `${Math.max(1, Math.round(minutes))} min read`;
}
